module.exports = __webpack_public_path__ + "img/Thailand.c87be301.jpg";